import { combineReducers } from 'redux'
import { GOALS_RECEIVED, GOAL_RECEIVED } from './actions'

const allIds = (state = [], action) => {
  const { type, payload } = action
  switch (type) {
    case GOALS_RECEIVED:
      if (payload == null) throw new Error('No observations')
      return [...state, ...payload.map(goal => goal.id)]
    case GOAL_RECEIVED:
      return [...state, payload.id]
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case GOALS_RECEIVED:
      return {
        ...state,
        ...payload.reduce(
          (s, goal) => ({
            ...s,
            [goal.id]: goal
          }),
          {}
        )
      }
    case GOAL_RECEIVED:
      return {
        ...state,
        [payload.id]: { ...payload }
      }
    default:
      return state
  }
}

export default combineReducers({
  allIds,
  byId
})

export const getAllGoals = state =>
  state.goals.allIds.map(id => state.goals.byId[id])

export const getGoalsFromPatientId = (state, patientId) =>
  getAllGoals(state).filter(
    goal =>
      goal.subject &&
      goal.subject.identifier &&
      goal.subject.identifier.value &&
      goal.subject.identifier.value === patientId
  )



// WEBPACK FOOTER //
// ./src/Goal/ducks.js